import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { Store } from 'builder/modules/store'

export const useTypedSelector: TypedUseSelectorHook<Store> = useSelector
